/* eslint-disable no-undef */
import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import CustomAutoComplete from "../../../../components/CustomAutoComplete";
import IntroductionFormApi from "../../../../services/api/introductionForm";
import { NEW_ENTRY_FIELDS } from "./formFields";
import AutoCompleteDropdown from "../../../../components/common/new/AutoCompleteDropdown/AutoCompleteDropdown";
import InputField from "../../../../components/common/new/InputField/InputField";
import { getOptions } from "../../../../utils";
import { REGEX } from "../../../../utils/validation/regex";
import SwitchButton from "../../../../components/common/SwitchButton/SwitchButton";
import Styles from "./CreateIntroductionForm.styles";
// import Dropdown from "../../../../components/common/new/Dropdown/Dropdown";

// const GENDER_TYPE = [
//   {
//     key: "Male",
//     value: "MALE",
//   },
//   {
//     key: "Female",
//     value: "FEMALE",
//   },
// ];

function NewEntryForm({ handleChange, errors, values, setFieldValue }) {
  const [divisions, setDivisions] = useState([]);
  const [subDivisions, setSubDivisions] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [toggle, settoggle] = useState(false);
  const [countries, setCountries] = useState([]);
  const [entryName, setEntryName] = useState("");
  const [entryAddress, setEntryAddress] = useState("");
  const [entryPincode, setEntryPincode] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [introducerName, setIntroducerName] = useState("");

  const REQUIRED_DIVISIONS = [52, 53];
  const getDivisions = async () => {
    const response = await IntroductionFormApi.getDivisions();
    setDivisions(response.data);
  };

  const getStates = async () => {
    const response = await IntroductionFormApi.getStates();
    setStates(response.data);
  };

  const getCountries = async () => {
    const response = await IntroductionFormApi.getCountries();
    setCountries(response.data);
  };

  // OLD (kept for future reference): used for debugging.
  // console.log("Division :", values[NEW_ENTRY_FIELDS.DIVISION]);

  useEffect(() => {
    getDivisions();
    getStates();
    getCountries();
  }, []);

  return (
    <div style={Styles.gridContainer}>
      <div style={{ ...Styles.gridItem, ...Styles.name }}>
        {/* <InputField
          required
          label="Name"
          name={NEW_ENTRY_FIELDS.NAME}
          value={values[NEW_ENTRY_FIELDS.NAME]}
          error={errors[NEW_ENTRY_FIELDS.NAME]}
          onChange={handleChange}
        /> */}
        <InputField
          required
          label="Name"
          name={NEW_ENTRY_FIELDS.NAME}
          value={entryName}
          error={errors[NEW_ENTRY_FIELDS.NAME]}
          style={Styles.textfieldStyle}
          onChange={(e) => {
            const { value } = e.target;
            // letters, digits, space, hyphen, apostrophe allowed
            // const regex = /^[A-Za-z ]*$/;
            const regex = REGEX.NAME_ALPHA_SPACE;
            if (regex.test(value)) {
              // Block leading space
              if (value.startsWith(" ")) return;

              // Block only spaces
              if (value.trim().length === 0 && value.length > 0) return;
              setEntryName(value);
              handleChange(e);
            }
          }}
        />
      </div>
      <div style={Styles.gridItem}>
        {/* <InputField
          required
          label="Address"
          value={values[NEW_ENTRY_FIELDS.ADDRESS_LINE_1]}
          name={NEW_ENTRY_FIELDS.ADDRESS_LINE_1}
          error={errors[NEW_ENTRY_FIELDS.ADDRESS_LINE_1]}
          onChange={handleChange}
        /> */}
        <InputField
          required
          label="Address"
          name={NEW_ENTRY_FIELDS.ADDRESS_LINE_1}
          value={entryAddress}
          error={errors[NEW_ENTRY_FIELDS.ADDRESS_LINE_1]}
          style={Styles.textfieldStyle}
          onChange={(e) => {
            const { value } = e.target;
            // letters, digits, space, comma, dot, hyphen, slash allowed
            // const regex = /^[A-Za-z0-9 ,.\-/]*$/;
            const regex = REGEX.ADDRESS_ALLOWED;
            if (regex.test(value)) {
              // Block leading space
              if (value.startsWith(" ")) return;

              // Block only spaces
              if (value.trim().length === 0 && value.length > 0) return;
              setEntryAddress(value);
              handleChange(e);
            }
          }}
        />
      </div>
      <div style={Styles.gridItem}>
        {/* <InputField
          label="Pincode"
          name={NEW_ENTRY_FIELDS.PINCODE}
          value={values[NEW_ENTRY_FIELDS.PINCODE]}
          onChange={handleChange}
          error={errors[NEW_ENTRY_FIELDS.PINCODE]}
          inputProps={{
            maxLength: 6,
          }}
        /> */}
        <InputField
          label="Pincode"
          name={NEW_ENTRY_FIELDS.PINCODE}
          value={entryPincode}
          error={errors[NEW_ENTRY_FIELDS.PINCODE]}
          inputProps={{
            maxLength: 6,
          }}
          style={Styles.textfieldStyle}
          onChange={(e) => {
            const { value } = e.target;
            // Only digits, max 6 characters
            // const regex = /^\d{0,6}$/;
            const regex = REGEX.PINCODE_UPTO_6_DIGITS;
            if (regex.test(value)) {
              setEntryPincode(value);
              handleChange(e);
            }
          }}
        />
      </div>
      {/* <div style={Styles.gridItem}>
        <InputField
          label="Address Line 2"
          name={NEW_ENTRY_FIELDS.ADDRESS_LINE_2}
          value={values[NEW_ENTRY_FIELDS.ADDRESS_LINE_2]}
          onChange={handleChange}
          error={errors[NEW_ENTRY_FIELDS.ADDRESS_LINE_2]}
        />
      </div> */}
      <div style={Styles.gridItem}>
        <AutoCompleteDropdown
          getOptionLabel={(option) => option.stateName}
          label="State"
          name={NEW_ENTRY_FIELDS.STATE}
          options={getOptions(states, "stateId")}
          error={errors[NEW_ENTRY_FIELDS.STATE]}
          value={values[NEW_ENTRY_FIELDS.STATE]}
          inputProps={{ required: true }}
          onChange={(selectedValue) => {
            if (!selectedValue) {
              setFieldValue(NEW_ENTRY_FIELDS.STATE, "");
              setCities([]);
            } else {
              setFieldValue(NEW_ENTRY_FIELDS.STATE, selectedValue.value);
              setCities(selectedValue.cities);
            }
            setFieldValue(NEW_ENTRY_FIELDS.CITY, "");
          }}
        />
      </div>
      <div style={Styles.gridItem}>
        <AutoCompleteDropdown
          getOptionLabel={(option) => option.cityName}
          label="City"
          name={NEW_ENTRY_FIELDS.CITY}
          options={getOptions(cities, "cityId")}
          error={errors[NEW_ENTRY_FIELDS.CITY]}
          value={values[NEW_ENTRY_FIELDS.CITY]}
          disabled={!values[NEW_ENTRY_FIELDS.STATE]}
          inputProps={{ required: true }}
          onChange={(selectedValue) => {
            if (!selectedValue) {
              setFieldValue(NEW_ENTRY_FIELDS.CITY, "");
            } else {
              setFieldValue(NEW_ENTRY_FIELDS.CITY, selectedValue.value);
            }
          }}
        />
      </div>
      {/* <div style={Styles.gridItem} /> */}
      <div style={Styles.gridItem}>
        {/* <InputField
          required
          label="Contact Number"
          name={NEW_ENTRY_FIELDS.CONTACT_NUMBER}
          onChange={handleChange}
          error={errors[NEW_ENTRY_FIELDS.CONTACT_NUMBER]}
          inputProps={{
            maxLength: 10,
          }}
        /> */}
        <InputField
          required
          label="Contact Number"
          name={NEW_ENTRY_FIELDS.CONTACT_NUMBER}
          value={contactNumber}
          error={errors[NEW_ENTRY_FIELDS.CONTACT_NUMBER]}
          style={Styles.textfieldStyle}
          inputProps={{
            maxLength: 10,
          }}
          onChange={(e) => {
            const { value } = e.target;
            // Only digits 0-9 allowed
            // const regex = /^[0-9]*$/;
            const regex = REGEX.DIGITS_ONLY;
            if (regex.test(value)) {
              setContactNumber(value);
              handleChange(e);
            }
          }}
        />
      </div>
      <div style={Styles.gridItem}>
        <InputField
          label="Email Address"
          name={NEW_ENTRY_FIELDS.EMAIL_ADDRESS}
          error={errors[NEW_ENTRY_FIELDS.EMAIL_ADDRESS]}
          // OLD (kept for future reference): allowed any text.
          // onChange={handleChange}
          onChange={(e) => {
            const { value } = e.target;
            // Allow blank. Otherwise disallow spaces and restrict to common email characters.
            // Final validation happens on submit (see handleValidation).
            // const emailCharRegex = /^[A-Za-z0-9@._+-]*$/;
            const emailCharRegex = REGEX.EMAIL_ALLOWED_CHARS;
            if (value === "" || emailCharRegex.test(value)) {
              handleChange(e);
            }
          }}
        />
      </div>
      <div style={Styles.gridItem}>
        <AutoCompleteDropdown
          getOptionLabel={(option) => option.name}
          label="Division"
          name={NEW_ENTRY_FIELDS.DIVISION}
          options={getOptions(divisions, "divisionId")}
          error={errors[NEW_ENTRY_FIELDS.DIVISION]}
          value={values[NEW_ENTRY_FIELDS.DIVISION]}
          inputProps={{ required: true }}
          onChange={(selectedValue) => {
            if (!selectedValue) {
              setFieldValue(NEW_ENTRY_FIELDS.DIVISION, "");
              setSubDivisions([]);
            } else {
              setFieldValue(NEW_ENTRY_FIELDS.DIVISION, selectedValue.value);
              setSubDivisions(selectedValue.subDivisions);
            }
            setFieldValue(NEW_ENTRY_FIELDS.SUB_DIVISION, "");
          }}
        />
      </div>
      <div style={Styles.gridItem}>
        <AutoCompleteDropdown
          getOptionLabel={(option) => option.name}
          name={NEW_ENTRY_FIELDS.SUB_DIVISION}
          options={getOptions(subDivisions, "divisionId")}
          error={errors[NEW_ENTRY_FIELDS.SUB_DIVISION]}
          value={values[NEW_ENTRY_FIELDS.SUB_DIVISION]}
          disabled={!values[NEW_ENTRY_FIELDS.DIVISION]}
          inputProps={
            REQUIRED_DIVISIONS.includes(values[NEW_ENTRY_FIELDS.DIVISION])
              ? { required: true }
              : { required: false }
          }
          label="Sub Division"
          onChange={(selectedValue) => {
            setFieldValue(
              NEW_ENTRY_FIELDS.SUB_DIVISION,
              selectedValue?.value ?? ""
            );
          }}
        />
      </div>
      {values[NEW_ENTRY_FIELDS.DIVISION] === 52 ||
      values[NEW_ENTRY_FIELDS.DIVISION] === 53 ? (
        <>
          <div style={Styles.gridItem}>
            <InputField
              required
              label="Parent's Contact Number"
              name={NEW_ENTRY_FIELDS.PARENT_CONTACT_NUMBER}
              value={values[NEW_ENTRY_FIELDS.PARENT_CONTACT_NUMBER]}
              onChange={handleChange}
              error={errors[NEW_ENTRY_FIELDS.PARENT_CONTACT_NUMBER]}
              inputProps={{
                maxLength: 10,
              }}
            />
          </div>
          <div style={Styles.gridItem}>
            <InputField
              label="Parent's Email Address"
              name={NEW_ENTRY_FIELDS.PARENT_EMAIL_ADDRESS}
              value={values[NEW_ENTRY_FIELDS.PARENT_EMAIL_ADDRESS]}
              error={errors[NEW_ENTRY_FIELDS.PARENT_EMAIL_ADDRESS]}
              onChange={handleChange}
            />
          </div>
        </>
      ) : null}
      <div style={Styles.gridItem}>
        <AutoCompleteDropdown
          getOptionLabel={(option) => option.countryName}
          name={NEW_ENTRY_FIELDS.NATIONALITY_ID}
          options={getOptions(countries, "countryId")}
          inputProps={{ required: true }}
          error={errors[NEW_ENTRY_FIELDS.NATIONALITY_ID]}
          value={values[NEW_ENTRY_FIELDS.NATIONALITY_ID]}
          label="Nationality/Country"
          onChange={(selectedValue) => {
            setFieldValue(
              NEW_ENTRY_FIELDS.NATIONALITY_ID,
              selectedValue?.value ?? ""
            );
          }}
        />
      </div>
      <div style={Styles.gridItem} />

      {/* <div style={Styles.gridItem}>
        <Dropdown
          name={NEW_ENTRY_FIELDS.GENDER}
          options={GENDER_TYPE}
          // inputProps={{ required: true }}
          value={values[NEW_ENTRY_FIELDS.GENDER]}
          label="Gender"
          onChange={handleChange}
        />
      </div> */}
      <div style={Styles.gridItem}>
        <Typography
          style={{
            fontSize: 12,
            color: " #8F92A1",
            fontWeight: 700,
          }}
        >
          Do you want to find the name of the introducer?
        </Typography>
        <Box sx={{ pt: "0.8rem" }}>
          <SwitchButton
            value={toggle}
            handleChange={(e) => {
              settoggle(e.target.checked);
              setFieldValue(NEW_ENTRY_FIELDS.INTRODUCED_BY_NAME, "");
              setFieldValue(NEW_ENTRY_FIELDS.INTRODUCED_BY_EMAIL, "");
              setFieldValue(NEW_ENTRY_FIELDS.INTRODUCED_BY_MOBILE_NUMBER, "");
              setFieldValue(NEW_ENTRY_FIELDS.INTRODUCED_BY, "");
            }}
          />
        </Box>
      </div>
      <div style={Styles.gridItem}>
        {toggle ? (
          <CustomAutoComplete
            required
            api={IntroductionFormApi.searchMembers}
            placeholder={toggle ? "Search an introducer" : ""}
            name={NEW_ENTRY_FIELDS.INTRODUCED_BY_NAME}
            setFieldValue={setFieldValue}
            error={errors[NEW_ENTRY_FIELDS.INRODUCER_NAME]}
            formatter={(val) => {
              if (val) {
                return val.split("-")[0];
              }
              return "";
            }}
            label="Introducer's Name"
            optionLabelId="fullName"
            optionValueId="fullName"
            withParam="memberName"
            selectedValue={(val) => {
              if (val.fullName) {
                setFieldValue(
                  NEW_ENTRY_FIELDS.INTRODUCED_BY_NAME,
                  String(val.fullName)
                );
              }

              if (val.memberId) {
                setFieldValue(NEW_ENTRY_FIELDS.INTRODUCED_BY, val.memberId);
              }

              if (val.emailId) {
                setFieldValue(
                  NEW_ENTRY_FIELDS.INTRODUCED_BY_EMAIL,
                  String(val.emailId)
                );
              }

              if (val.mobileNumber) {
                setFieldValue(
                  NEW_ENTRY_FIELDS.INTRODUCED_BY_MOBILE_NUMBER,
                  String(val.mobileNumber)
                );
              }
            }}
            isServerSide
            // value={values[NEW_ENTRY_FIELDS.INRODUCER_NAME]}
            options={[]}
          />
        ) : (
          // <InputField
          //   required
          //   label="Introducer's Name"
          //   name={NEW_ENTRY_FIELDS.INTRODUCED_BY_NAME}
          //   onChange={handleChange}
          //   error={errors[NEW_ENTRY_FIELDS.INTRODUCED_BY_NAME]}
          // />
          <InputField
            required
            label="Introducer's Name"
            name={NEW_ENTRY_FIELDS.INTRODUCED_BY_NAME}
            value={introducerName}
            error={errors[NEW_ENTRY_FIELDS.INTRODUCED_BY_NAME]}
            onChange={(e) => {
              const { value } = e.target;
              const regex = /^[A-Za-z ]*$/; // Allowed characters
              if (regex.test(value)) {
                // Block leading space
                if (value.startsWith(" ")) return;

                // Block only spaces
                if (value.trim().length === 0 && value.length > 0) return;
                setIntroducerName(value);
                handleChange(e); // Formik ko bhi update karega
              }
            }}
          />
        )}
      </div>
      <div style={Styles.gridItem}>
        {/* <InputField
          required
          label="Introducer's Contact Number"
          name={NEW_ENTRY_FIELDS.INTRODUCED_BY_MOBILE_NUMBER}
          value={values[NEW_ENTRY_FIELDS.INTRODUCED_BY_MOBILE_NUMBER] || ""}
          disabled={toggle}
          onChange={handleChange}
          error={errors[NEW_ENTRY_FIELDS.INTRODUCED_BY_MOBILE_NUMBER]}
          inputProps={{
            maxLength: 10,
          }}
        /> */}
        <InputField
          required
          label="Introducer's Contact Number"
          name={NEW_ENTRY_FIELDS.INTRODUCED_BY_MOBILE_NUMBER}
          value={values[NEW_ENTRY_FIELDS.INTRODUCED_BY_MOBILE_NUMBER] || ""}
          disabled={toggle}
          onChange={(e) => {
            const { value } = e.target;
            // Only digits allowed
            const regex = /^[0-9]*$/;

            if (regex.test(value)) {
              setFieldValue(
                NEW_ENTRY_FIELDS.INTRODUCED_BY_MOBILE_NUMBER,
                value
              );
              handleChange(e);
            }
          }}
          error={errors[NEW_ENTRY_FIELDS.INTRODUCED_BY_MOBILE_NUMBER]}
          inputProps={{
            maxLength: 10, // Indian mobile number length
          }}
        />
      </div>
      <div style={Styles.gridItem}>
        <InputField
          label="Introducer's Email Address"
          name={NEW_ENTRY_FIELDS.INTRODUCED_BY_EMAIL}
          value={values[NEW_ENTRY_FIELDS.INTRODUCED_BY_EMAIL] || ""}
          disabled={toggle}
          // OLD (kept for future reference): allowed any text.
          // onChange={handleChange}
          onChange={(e) => {
            const { value } = e.target;
            // When toggle is ON, this field is disabled anyway.
            const emailCharRegex = /^[A-Za-z0-9@._+-]*$/;
            if (value === "" || emailCharRegex.test(value)) {
              handleChange(e);
            }
          }}
          error={errors[NEW_ENTRY_FIELDS.INTRODUCED_BY_EMAIL]}
        />
      </div>
    </div>
  );
}

const propTypes = {
  handleChange: PropTypes.func.isRequired,
  errors: PropTypes.objectOf(PropTypes.string).isRequired,
  values: PropTypes.objectOf(PropTypes.string).isRequired,
  setFieldValue: PropTypes.func.isRequired,
};

NewEntryForm.propTypes = propTypes;

export default NewEntryForm;
